module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "a7932dc",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
